var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"member"}},[(_vm.$store.state.device == 'mob')?_c('mMember'):_vm._e(),(_vm.$store.state.device == 'pc')?_c('pMember'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }